import classNames from 'classnames'
import React, { FC, useContext, useEffect } from 'react'
import Dropdown from '~/components/common/Dropdown'
import Tooltip from '~/components/common/Tooltip'
import { ChatContext } from '~/service/chatConn'
import { FormType } from '..'
import { Control, Controller } from 'react-hook-form'
import { RenderPropsTyped } from '~/components/common/Form'

type Props = {
  control: Control<FormType, any>
}

const AiLang: FC<Props> = ({ control }) => (
  <Controller
    name="aiLang"
    control={control}
    render={renderProps => <AiLangField renderProps={renderProps} />}
  />
)

export default AiLang

type RedirectFieldProps = {
  renderProps: RenderPropsTyped<FormType, 'aiLang'>
}

const AiLangField: FC<RedirectFieldProps> = ({ renderProps }) => {
  const {
    field: { value, onChange },
  } = renderProps

  return (
    <Dropdown
      // right={true}
      up={true}
      trigger={
        <Tooltip
          content={intl.formatMessage({
            id: 'chat / input / redirect / tooltip',
          })}
        >
          <button type="button">
            {/* <span className="far fa-share" /> */}
            {value.toUpperCase()}
          </button>
        </Tooltip>
      }
    >
      <Inner onSelect={lang => onChange(lang)} selected={value} />
    </Dropdown>
  )
}

type InnerProps = {
  onSelect: (lang: string) => void
  selected: string
}

const Inner: FC<InnerProps> = ({ onSelect, selected }) => {
  const langs = ['en', 'pl', 'sv', 'de', 'fi', 'es']

  return (
    <>
      {langs.map(lang => (
        <a
          key={lang}
          className={classNames('dropdown-item', {
            'is-active': selected == lang,
          })}
          onClick={() => onSelect(lang)}
        >
          {lang.toUpperCase()}
        </a>
      ))}
    </>
  )
}
